import { useEffect, useState } from "react";
import { formatScheduleEventDateTime } from "../../../helpers";
import { useScheduleStore } from "../../hooks";
import { MainButton } from "../../ui";

export const ScheduleList = ({
  handleSelectEventRadio,
  handleAutoSubmitFilterForm,
  formStateFilterForm,
  setIsConfirmAssessmentModal,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    schedule,
  } = useScheduleStore();

  const { scheduleEvents: scheduleEventsSchedule } = schedule;

  // States ------------------------------------------------//
  const [scheduleEvents, setScheduleEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    const newscheduleEvents = scheduleEventsSchedule.map((scheduleEvent) => ({
      ...scheduleEvent,
      start: new Date(scheduleEvent.start),
      end: new Date(scheduleEvent.end),
    }));

    setScheduleEvents(newscheduleEvents);
    setSelectedEventId(null);
  }, [scheduleEventsSchedule]);

  const showScheduleButton =
    selectedEventId !== null && selectedEventId !== "no-suitable-time";

  if (scheduleEvents.length === 0) {
    return (
      <div className="card border">
        <div className="card-body text-center">
          <p className="mb-0">No hay horarios disponibles</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card border border-top-0">
      <div className="card-body" style={{ marginTop: "-60px" }}>
        <div className="vstacks gap-2">
          <label className="form-label mb-2">Fecha de agendamiento</label>
          <div className="row">
            {scheduleEvents.map((event, index) => {
              const eventId = `event-${index}`;
              return (
                <div key={index} className="col-auto">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="scheduleEvent"
                      id={eventId}
                      checked={selectedEventId === eventId}
                      onChange={() => {
                        setSelectedEventId(eventId);
                        handleSelectEventRadio(event);
                      }}
                    />
                    <label
                      className="form-check-label fw-normal"
                      htmlFor={eventId}
                    >
                      {formatScheduleEventDateTime(event.start)}
                    </label>
                  </div>
                </div>
              );
            })}
            <div className="col-auto">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="scheduleEvent"
                  id="no-suitable-time"
                  checked={selectedEventId === "no-suitable-time"}
                  onChange={() => {
                    setSelectedEventId("no-suitable-time");
                    handleAutoSubmitFilterForm({
                      formState: formStateFilterForm,
                    });
                  }}
                />
                <label
                  className="form-check-label fw-normal"
                  htmlFor="no-suitable-time"
                >
                  No encuentro un horario adecuado
                </label>
              </div>
            </div>
          </div>

          {showScheduleButton && (
            <MainButton
              type={"button"}
              onClick={() => setIsConfirmAssessmentModal(true)}
            >
              Agendar
            </MainButton>
          )}
        </div>
      </div>
    </div>
  );
};
